import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import type { InvResourceId } from "@brewbase/db/types";
import { NeedsTable } from "@/features/bottle-prep/needs-table";
import { PrepPanes } from "@/features/bottle-prep/prep-panes";
import type { PrepSeed } from "@/features/bottle-prep/prep-form-model";
import { PrepareForm } from "@/features/bottle-prep/prepare-form";
import { usePrepSeed } from "@/features/bottle-prep/use-prep-seed";

export const Route = createFileRoute("/fermentations/bottles")({
  component: BottlesPage,
  head: () => ({ meta: [{ title: "BrewBase - Bottles" }] }),
});

/**
 * Fermentations › Bottles: Needs on top, then the prepare form in the same
 * three panes as the journal's dialog. The page owns the form's seed so Needs
 * (Prep) and Recent (Repeat) can load the form through `load`.
 */
function BottlesPage() {
  const prep = usePrepSeed();
  const [pickedOutput, setPickedOutput] = useState<InvResourceId | null>(null);
  const output = pickedOutput ?? prep.seed.outputResourceId ?? null;
  const load = (seed: PrepSeed) => {
    setPickedOutput(null);
    prep.load(seed);
  };

  return (
    <div className="flex flex-col gap-6 mt-2 container mx-auto">
      <section aria-label="Needs" className="flex flex-col gap-2">
        <h2 className="text-base font-semibold">Needs</h2>
        <NeedsTable onPrep={load} />
      </section>
      <section aria-label="Prepare" className="flex flex-col gap-2">
        <h2 className="text-base font-semibold">Prepare</h2>
        <PrepareForm
          key={prep.key}
          seed={prep.seed}
          onOutputChange={setPickedOutput}
          layout={(parts) => <PrepPanes parts={parts} output={output} onRepeat={load} />}
        />
      </section>
    </div>
  );
}
